export enum appActionTypes {
  APP_LOADING = 'APP_LOADING',
  APP_FAILURE = 'APP_FAILURE',
  SET_LANG = 'SET_LANG',
  SET_CONTROLLERS_DATA = 'SET_CONTROLLERS_DATA',
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  REGISTER_ROUTE = 'REGISTER_ROUTE',
  BACKDROP_LOADING = 'BACKDROP_LOADING',
  BAR_LOADING = 'BAR_LOADING',
}
